import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  search: '',
};

export const clientsRecentList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.CLIENTS_RECENT_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.CLIENTS_RECENT_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case actionTypes.CLIENTS_RECENT_LIST_SUCCESS:
    case actionTypes.CLIENTS_RECENT_LIST_UPDATE:
      return {
        ...state,
        loading: false,
        data: action.payload || [],
      };

    default:
      return state;
  }
};

export default clientsRecentList;
